import { render, staticRenderFns } from "./Buyers.vue?vue&type=template&id=17ca3d34&scoped=true"
import script from "./Buyers.vue?vue&type=script&lang=js"
export * from "./Buyers.vue?vue&type=script&lang=js"
import style0 from "./Buyers.vue?vue&type=style&index=0&id=17ca3d34&prod&lang=css"
import style1 from "./Buyers.vue?vue&type=style&index=1&id=17ca3d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ca3d34",
  null
  
)

export default component.exports